export default __webpack_public_path__ + "static/media/Machine State, Printing.1f47b3b2.png";